module.exports = __webpack_public_path__ + "static/media/retrato_9.86f74210.jpg";